import React from 'react';

import PropTypes from 'prop-types';

import { DividingLine } from 'components/DividingLine/DividingLine';
import { HistoricalMessage } from 'components/MyTaskArea/TaskDetailPage/CommentHistory/HistoricalMessage';
import { MessageType } from 'components/MyTaskArea/types';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './CommentHistory.sass';

export const CommentHistory = ({ messages, onDownloadAttachment, entityNameMap }) => {
  if (!messages?.length) {
    return null;
  }

  const sortedMessages = [...messages].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  );

  return (
    <div className="comment-history">
      <SubTitle text="Nachrichtenverlauf" notFramed className="task-details__card-title" />
      {sortedMessages.map((message, index) => (
        <div key={message.id} className="comment-history__message">
          <HistoricalMessage
            message={message}
            onDownloadAttachment={onDownloadAttachment}
            entityNameMap={entityNameMap}
          />
          {index !== sortedMessages.length - 1 && <DividingLine />}
        </div>
      ))}
    </div>
  );
};

CommentHistory.propTypes = {
  messages: PropTypes.arrayOf(MessageType),
  onDownloadAttachment: PropTypes.func,
  entityNameMap: PropTypes.object,
};

CommentHistory.defaultProps = {
  messages: [],
  onDownloadAttachment: () => {},
  entityNameMap: {},
};
